<template>
	<div class="relative" style="white-space: nowrap;">
		<input ref="input" :name="name" type="text" v-model="inputValue" maxlength="127" :size="size" :tabindex="tabindex"
		 @keydown.up.capture.stop="goUp" @keydown.down.capture.stop="goDown" @focusout="focusOut"
		 @keydown.enter.capture.stop.prevent="selectSelectedResult" @keyup.enter.capture.stop
		 @keyup.up.capture.stop @keyup.down.capture.stop :disabled="pickSelected"
		 @keyup="sendData(canSendData())" :placeholder="placeholder" autocomplete="off"
		 class="w-full px-4 py-3 border-2 border-gray-300 rounded-lg text-lg focus:border-blue-500 focus:outline-none transition-colors"
		 >
		<div v-show="pickSelected"style="padding-left: 5px;"  class="close-button bg-red-500 rounded-full w-6 h-6 flex items-center justify-center absolute -top-2 -right-2 redCross" 
			@click="resetValue">
			<svg class="w-6 h-6 text-white" fill="currentColor" viewBox="3 0 24 24">
				<path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/>
			</svg>
		</div>
	</div>
	<ul v-if="results.length>0" class="bg-gradient-to-r from-blue-50 to-indigo-50 rounded-xl shadow-md p-4 border border-blue-100 zipItems">
		<li v-for="(item,index) in results" class="text-lg text-gray-700 zipItem" :class="selectedItem(selected===index)" :key="item.key"
			 @click="selectResult(item)" @mouseenter="setSelected(index)" >{{item.value}}</li>
	</ul>

	<div v-show="isError" class="bg-white rounded-xl shadow-md p-6 max-w-4xl mx-auto inline-block" style="padding-top: 10px;">
		<p class="text-red-700 leading-relaxed text-lg" v-html="errorMessage"></p>
	</div>
</template>

<script setup lang="ts">
	import { ref, computed, onMounted } from 'vue';
	import { useAutocomplete, SuggestResult } from '@/vue/form/Autocomplete';
	
	const props = defineProps({
		restApi: String,
		params: String,
		suggestEmpty: Boolean,
		size: Number,
		placeholder: String,
		tabindex: Number,
		name: String,
		value: String,
		modelValue: String,
		mode: String,
		focus: Boolean
	});
	
	const input = ref(null);
	
	const emit = defineEmits(['update:modelValue','updateInputValue']);
	
	const { results, selected, errorMessage, isError, progress, inputValue,
		sendData, selectResult, selectSelectedResult, resetValue, suggestedKey,  
		setSelected, goUp, goDown, focusOut, pickSelected } = useAutocomplete(props,emit,afterSelectResult);
		
	function selectedItem(selected: boolean): string {
		return selected?"bg-gradient-to-r from-blue-200 to-indigo-50 font-semibold ":"";
	}
		
	function canSendData(): boolean {
		//console.log("suggestEmpty:"+props.suggestEmpty+" path value:"+pathFolder.value.length);
		return props.suggestEmpty || (pathFolder.value && pathFolder.value.length>=3);
	}
	
	function afterSelectResult(result: SuggestResult): void {
		if (result === null && inputValue.value && inputValue.value.length>=5) {//nothing found
			errorMessage.value="V oblasti s tímto PSČ není prodejce. "
					+"Časopis si můžete objednat z doručením zdarma na "
					+"<a href='https://www.espritbohemia.cz' target='_blank'"
					+" class='text-gray-800 hover:text-red-600 hover:underline transition-colors'>www.espritbohemia.cz</a>";
		}
		input.value.focus();
	}
	
	const pathFolder = computed(() => {
		return inputValue.value;
	});
	
	onMounted(() => {
		if (props.focus) {
			input.value.focus();
		}
	});
	
</script>

